<template>
  <table class="tw-table-fixed">
    <thead>
      <tr class="tw-bg-true-gray-50 tw-rounded tw-text-gray-600">
        <th class="tw-font-normal">{{ $t('Field') }}</th>
        <th class="tw-font-normal">{{ $t('Value') }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="customFieldValue in customFieldsData"
        :key="customFieldValue.id"
        class="tw-border-b tw-border-t-0 tw-border-r-0 tw-border-l-0 tw-border-solid tw-border-gray-100"
      >
        <td class="tw-w-1/2">{{ customFieldValue.customField.title }}</td>
        <td class="tw-w-1/2">{{ customFieldValue.displayValue }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script setup lang="ts">
import {computed} from "vue"
import {FragmentType, useFragment} from '@/gql'
import { CUSTOM_FIELD_VALUES_VIEW_FRAGMENT } from '@/components/Fieldable/graphql/fragments'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'

const props = defineProps<{
  customFieldValues: FragmentType<typeof CUSTOM_FIELD_VALUES_VIEW_FRAGMENT>[]
}>()

const customFieldsData = computed(() => props.customFieldValues.map(customFieldValue => useFragment(CUSTOM_FIELD_VALUES_VIEW_FRAGMENT, customFieldValue)))
</script>

<style scoped lang="scss">
td,
th {
  @apply tw-py-1;
  @apply tw-px-2;
}

thead > tr > th {
  &:first-child {
    @apply tw-rounded-tl-lg;
    @apply tw-rounded-bl-lg;
  }
  &:last-child {
    @apply tw-rounded-tr-lg;
    @apply tw-rounded-br-lg;
  }
}
</style>
